class Resources {
  constructor() {
    this.rootLocation = window.location.href
    this.paginationButton = $("#pagination")
    this.resourcesGrid = $(".resources-grid")
    this.paginationList = $(".pagination-list > *")
    this.lightboxButtons = $(".experience-levels a")
    this.lightbox = $(".lightbox")
    this.ajaxPosts = $("#ajax-posts")
    this.ajaxLoader = $("#ajax-loader")
    this.selects = $("select.resource-filter")
    this.form = $("#filters-form")
    this.searchForm = $("form.search-form")
    this.searchFormValue = ""
    this.currentFilters = []
  }
  updateFilter(filter, value) {
    const index = this.currentFilters.findIndex(
      item => item.filterName == filter
    )
    this.currentFilters[index].filterValue = value
  }
  insertNewFilter(filter, value) {
    this.currentFilters.push({
      filterName: filter,
      filterValue: value,
    })
  }
  isFilterAlreadySelected(current) {
    const check = this.currentFilters.filter(item => item.filterName == current)
    return check.length >= 1 ? true : false
  }
  createURLRequest() {
    let query = ""

    if (this.searchFormValue !== "") {
      query += `?text=${this.searchFormValue}`
    }
    // We filter another array before to display the values.
    let fileteredArray = this.currentFilters.filter(
      item => item.filterValue !== "all"
    )
    console.log("fileteredArray: ", fileteredArray)
    if (fileteredArray.length) {
      query += query.length ? "&" : "?"
      fileteredArray.forEach((item, index) => {
        query += `${item.filterName}=${item.filterValue}`
        if (index !== fileteredArray.length - 1) {
          query += "&"
        }
      })
    }
    return query
  }
  filterResources() {
    this.resourcesGrid.addClass("searching")
    console.log("this.searchFormValue request: ", this.searchFormValue)
    if (this.searchFormValue !== "") {
      this.paginationList.hide()
    }
    const query = this.createURLRequest()
    if (query === "") {
      this.resourcesGrid.removeClass("searching")
      this.paginationList.show()
    }
    const urlRequested = window.location.pathname + query
    $.get(urlRequested, data => {
      const result = $(data).find("#ajax-posts").html()
      $("#ajax-posts").empty().append(result)
      this.paginationButton.empty()
      this.paginationButton.load(urlRequested + " #pagination>*", res => {})
    })
    window.history.pushState(null, null, window.location.pathname + query)
  }
  requestNextPage(url) {
    this.ajaxLoader.empty()
    this.ajaxLoader.load(url + " #ajax-posts>*", () => {
      this.ajaxPosts.append(this.ajaxLoader.children())
    })
    this.paginationButton.load(url + " #pagination>*", res => {})
  }
  requestPage(url) {
    this.resourcesGrid.addClass("searching")
    console.log("this.searchFormValue request: ", this.searchFormValue)
    if (this.searchFormValue !== "") {
      this.paginationList.hide()
    }
    this.ajaxLoader.empty()
    this.ajaxLoader.load(url + " #ajax-posts>*", () => {
      this.ajaxPosts.empty().append(this.ajaxLoader.children())
    })
    this.paginationButton.load(url + " #pagination>*", res => {})
  }
  handlePagination() {
    this.paginationButton.on("click", "a", e => {
      e.preventDefault()
      const button = $(e.delegateTarget)
      const url = button.find("a").attr("href")
      console.log("url: ", url)
      window.history.pushState(null, null, url)
      this.requestNextPage(url)
    })
  }
  handleLightbox() {
    this.lightboxButtons.on("click", e => {
      e.preventDefault()
      const $this = $(e.delegateTarget)
      const value = $this.data("experience-level")
      const url = "/resource-center/?experience-level=" + value
      console.log("url: ", url)
      window.history.pushState(null, null, url)
      this.requestPage(url)
      this.closeModal()
      $("select.resource-filter-experience-level").val(value).trigger("change")
    })
  }
  handleSelects() {
    this.selects.on("change", el => {
      const $this = $(el.delegateTarget)
      const filter = $this.attr("name")
      const value = $this.val()
      console.log(value)
      if (!this.isFilterAlreadySelected(filter)) {
        this.insertNewFilter(filter, value)
      } else {
        this.updateFilter(filter, value)
        console.log("filter and filter value already exists")
      }
      //this.filterResources()
    })
  }
  closeModal() {
    $("#level-of-content-modal").fadeOut("200")
  }
  handleSearchForm() {
    this.searchFormInput = this.searchForm.find("input")
    this.searchFormInput.on("keyup", e => {
      this.searchFormValue = $(e.delegateTarget).val()
      this.searchFormValue = this.searchFormValue.replace(/ /g, "+")
    })
    this.searchForm.on("submit", e => {
      this.searchFormValue = this.searchForm.find("input").val()
      if (this.searchFormValue.length > 0) {
        this.searchFormValue = this.searchFormValue.replace(/ /g, "+")
        const url = "/knowledge-center/?text=" + this.searchFormValue
        window.history.pushState(null, null, url)
        this.paginationList.hide()
        this.requestPage(url)
      } else {
        window.history.pushState(null, null, "/knowledge-center/")
        this.requestPage("/knowledge-center/")
        this.resourcesGrid.removeClass("searching")
        this.paginationList.show()
      }

      e.preventDefault()
    })
  }
  init() {
    this.handleSelects()
    this.handleSearchForm()
    this.form.on("submit", e => {
      e.preventDefault()
      this.filterResources()
    })
  }
}

export default {
  init() {
    if ($(".block-knowledge-center").length) {
      const resources = new Resources()
      resources.init()
    }
  },
}
